export default {
  meta: {
    title: '店铺评分模型',
  },
};
